import { camelize, dasherize } from '@ember/string';
import FilterConstants from '../filter-constants';
import * as Format from './format';
import { clone, isNearInfinity } from './common';
import RSVP from 'rsvp';
import { isSOIC, isSOICEP, isMSOP, isMSOPEP, isSOT23 } from './package-checker';

//////////////////////////////////////////////////////////////////////////////////////////////
// materials - utility functions returns actual components for BOM and Evaluation Boards    //
//////////////////////////////////////////////////////////////////////////////////////////////

export function getOpAmpReferenceDesignator(packageCode, channels) {
  let refDesignatorOpAmp = 'U1';
  // get the reference designator for opAmp
  switch (parseFloat(channels)) {
    case 1: {
      refDesignatorOpAmp = isSOIC(packageCode) || isSOICEP(packageCode) ? 'U1' : isSOT23(packageCode) ? 'U2' : 'U1';
      break;
    }
    case 2: {
      refDesignatorOpAmp =
        isSOIC(packageCode) || isSOICEP(packageCode)
          ? 'U1'
          : isMSOP(packageCode) || isMSOPEP(packageCode)
            ? 'U2'
            : 'U1';
      break;
    }
    default: {
      break;
    }
  }
  return refDesignatorOpAmp;
}
export function getCapacitorPackage(value, toleranceValue, isReferenceCircuit) {
  let result = _materialAndPackageForCapacitors(value, toleranceValue, isReferenceCircuit);
  return result.package;
}
export function billOfMaterials(
  filterType,
  specificationsInput,
  vsMinus,
  stageDetails,
  circuitDetails,
  toleranceInput,
  needReferenceStage,
  opAmpSource,
) {
  let billOfMaterialsFinal = new Array();
  let boolReferenceBoard = false;
  let billOfMaterialObj = [];
  let stageCount = stageDetails.length;

  // Loop through Stages
  for (let i = 0; i < stageCount; i++) {
    let circuitData = stageDetails[i].circuitResult.circuit;
    let supportedComponents = stageDetails[i].circuitResult.circuit.supportedComponents;
    let toleranceComponents = _getToleranceComponents(circuitData, supportedComponents);
    let validCapacitors, validResistors, validInductors;
    [validCapacitors, validResistors, validInductors] = _getValidCapacitorsAndResistors(
      stageDetails[i],
      circuitDetails[i],
      true,
    );

    // get the finishing touches for the current component
    let finishingTouchesCurrentComp = _finishingTouches(vsMinus);

    // get bill of materials of all the resistors in current component object
    billOfMaterialObj = billOfMaterialObj.concat(
      _getResistorBOM(stageDetails[i], validResistors, toleranceComponents, toleranceInput.resistorTolerance),
    );

    // get bill of materials for all the capacitors for the current component object
    billOfMaterialObj = billOfMaterialObj.concat(
      _getCapacitorBOM(
        stageDetails[i],
        validCapacitors,
        toleranceComponents,
        toleranceInput.capacitorTolerance,
        boolReferenceBoard,
      ),
    );

    // get bill of materials for all the inductors for the current component object
    billOfMaterialObj = billOfMaterialObj.concat(
      _getInductorBOM(
        stageDetails[i],
        validInductors,
        toleranceComponents,
        toleranceInput.inductorTolerance,
        specificationsInput,
        filterType,
      ),
    );

    // get the bill of materials for current component OpAmp
    billOfMaterialObj = billOfMaterialObj.concat(_getOpAmpBOM(stageDetails[i], opAmpSource));

    // get bill of materials for bypassCapacitors
    billOfMaterialObj = billOfMaterialObj.concat(
      _getBypassCapacitorsBOM(
        finishingTouchesCurrentComp.bypassCapacitors,
        stageDetails[i].stageLetter,
        boolReferenceBoard,
      ),
    );
  }

  // get bill of materials for referenceCircuit stage if any
  if (needReferenceStage) {
    let refCircuitArray = _getReferenceStage();

    // loop through the reference circuit Array and push the designators, values, materials, packages, and tolerances to the billOfMaterials
    for (let s = 0; s < refCircuitArray.length; s++) {
      let productURL = null;
      if (
        refCircuitArray[s].refDesignator &&
        refCircuitArray[s].refDesignator.length > 0 &&
        refCircuitArray[s].refDesignator[0] === 'U'
      )
        productURL = '{{homeURL}}' + '/' + refCircuitArray[s].value + '.html';
      billOfMaterialObj.push({
        refDesignator: refCircuitArray[s].refDesignator,
        value: refCircuitArray[s].value,
        prodURL: productURL,
        package: refCircuitArray[s].package,
        material: refCircuitArray[s].material,
        tolerance: refCircuitArray[s].tolerance,
        italicRow: false,
      });
    }
  }

  // get bill of materials for tantalum capacitors
  var tantalumCapacitor = _getTantalumCapacitors(vsMinus);

  // loop through the tantalum capacitors to get the bill of materials
  for (var q = 0; q < tantalumCapacitor.length; q++) {
    var tantalumCapMaterialsAndPackage = _materialAndPackageForCapacitors(
      tantalumCapacitor[q].value,
      tantalumCapacitor[q].tolerance,
      true,
    );
    billOfMaterialObj.push({
      refDesignator: tantalumCapacitor[q].designator,
      value: tantalumCapacitor[q].value,
      prodURL: null,
      package: tantalumCapMaterialsAndPackage.package,
      material: tantalumCapMaterialsAndPackage.material,
      tolerance: tantalumCapacitor[q].tolerance,
      italicRow: false,
    });
  }

  // separating the resistors, capacitors and opAmps from the billOfMaterials Object
  let billOfMaterialsResistorArray = new Array(),
    billOfMaterialsCapacitorArray = new Array(),
    billOfMaterialsOpAmpArray = new Array(),
    billOfMaterialsInductorArray = new Array();

  for (let a = 0; a < billOfMaterialObj.length; a++) {
    // excluding the resistors which has value zero or infinity since they are not used by the circuit
    if (billOfMaterialObj[a].refDesignator.charAt(0) === 'R' && !isNearInfinity(billOfMaterialObj[a].value)) {
      billOfMaterialsResistorArray.push(billOfMaterialObj[a]);
    }
    // excluding the capacitors which has value zero or infinity since they are not used by the circuit
    else if (billOfMaterialObj[a].refDesignator.charAt(0) === 'C' && !isNearInfinity(billOfMaterialObj[a].value)) {
      billOfMaterialsCapacitorArray.push(billOfMaterialObj[a]);
    } else if (billOfMaterialObj[a].refDesignator.charAt(0) === 'U') {
      billOfMaterialsOpAmpArray.push(billOfMaterialObj[a]);
    } else if (billOfMaterialObj[a].refDesignator.charAt(0) === 'L') {
      billOfMaterialsInductorArray.push(billOfMaterialObj[a]);
    }
  }

  // make call return an object containing a resistorsObjectArray and an otherArray
  let extraComponents = _getExtraComponentsBOM(
    stageDetails,
    _getExtraComponentsCount(stageDetails.length),
    needReferenceStage,
  );

  billOfMaterialsResistorArray = billOfMaterialsResistorArray.concat(extraComponents.resistorAdditions);

  // getting the bill Of Material grouping for resistor array table and adding the unit for resistors
  let resistorTable = _billOfMaterialsTable(billOfMaterialsResistorArray, true, 'Ω');

  // getting the bill of Material grouping for capacitor array table and adding the unit for capacitors
  let capacitorTable = _billOfMaterialsTable(billOfMaterialsCapacitorArray, true, 'F');

  // getting the bill of Material grouping for capacitor array table and adding the unit for capacitors
  let inductorTable = _billOfMaterialsTable(billOfMaterialsInductorArray, true, 'H');

  // getting the bill of material grouping for opAmp table
  let opAmpTable = _billOfMaterialsTable(billOfMaterialsOpAmpArray, false, null);

  billOfMaterialsFinal = resistorTable.concat(inductorTable.concat(capacitorTable.concat(opAmpTable)));
  billOfMaterialsFinal = billOfMaterialsFinal.concat(extraComponents.otherAdditions);
  return billOfMaterialsFinal;
}
export function orderEvalBoard(vsMinus, stageDetails, circuitDetails, toleranceInput, needReferenceStage, opAmpSource) {
  let orderEvalBoardArray = new Array();

  // get the motherboard designators
  let motherboardDesignatorArray = _motherBoardDesignators(vsMinus, needReferenceStage);
  //looping through motherboardDesignator Array to get the required format
  let motherboardStrDesignator = '';
  for (let k = 0; k < motherboardDesignatorArray.length; k++) {
    if (motherboardStrDesignator.length > 0) motherboardStrDesignator += ',';
    motherboardStrDesignator += motherboardDesignatorArray[k];
  }
  //make call return an object containing a resistorsObjectArray and an otherArray
  let extraComponents = _getExtraComponentsBOM(
    stageDetails,
    _getExtraComponentsCount(stageDetails.length),
    needReferenceStage,
  );
  // add extras to motherboard Designator (4 or 5 in the case of 4 and 7/8 for the case of 8)
  switch (extraComponents.otherAdditions.length) {
    case 4:
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[0].designators;
      motherboardStrDesignator += ',' + extraComponents.resistorAdditions[0].refDesignator;
      motherboardStrDesignator += ',' + extraComponents.resistorAdditions[1].refDesignator;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[2].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[3].designators;
      break;
    case 5:
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[0].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[1].designators;
      motherboardStrDesignator += ',' + extraComponents.resistorAdditions[0].refDesignator;
      motherboardStrDesignator += ',' + extraComponents.resistorAdditions[1].refDesignator;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[3].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[4].designators;
      break;
    case 7:
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[0].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[1].designators;
      motherboardStrDesignator += ',' + extraComponents.resistorAdditions[0].refDesignator;
      motherboardStrDesignator += ',' + extraComponents.resistorAdditions[1].refDesignator;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[3].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[4].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[5].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[6].designators;
      break;
    case 8:
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[0].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[1].designators;
      motherboardStrDesignator += ',' + extraComponents.resistorAdditions[0].refDesignator;
      motherboardStrDesignator += ',' + extraComponents.resistorAdditions[1].refDesignator;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[3].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[4].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[5].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[6].designators;
      motherboardStrDesignator += ',' + extraComponents.otherAdditions[7].designators;
      break;
  }
  // add it to the eval board array
  let evalBoardMotherModelNum = FilterConstants.evalBoard.fileBase.replace(
    '{{type}}{{implementation}}{{channel}}',
    FilterConstants.evalBoard.mother,
  );
  orderEvalBoardArray.push({
    stage: '',
    stageType: 'none',
    stageImplementation: 'none',
    stageChannel: 'none',
    evalBoardModelNumber: evalBoardMotherModelNum,
    partsOnEvalBoard: motherboardStrDesignator,
  });

  // loop for each stage
  let stageCount = stageDetails.length;
  for (let i = 0; i < stageCount; i++) {
    let strDesignator = '';
    let validCapacitors, validResistors;
    [validCapacitors, validResistors] = _getValidCapacitorsAndResistors(stageDetails[i], circuitDetails[i], false);

    // get reference designator of all the resistors in current component object
    for (let j = 0; j < validResistors.length; j++) {
      // check for resistors for zero value and infinity values
      if (!isNearInfinity(validResistors[j].value)) {
        let refDesignatorResistor = _referenceDesignator(
          stageDetails[i],
          validResistors[j].name,
          validResistors[j].value,
          toleranceInput.resistorTolerance,
        );
        strDesignator += strDesignator.length > 0 ? ',' + refDesignatorResistor : refDesignatorResistor;
      }
    }
    // get reference designator for all the capacitors for the current component object
    for (var k = 0; k < validCapacitors.length; k++) {
      // check for capacitors for zero values and infinity values
      if (!isNearInfinity(validCapacitors[k].value)) {
        let refDesignatorCapacitor = _referenceDesignator(
          stageDetails[i],
          validCapacitors[k].name,
          validCapacitors[k].value,
          toleranceInput.capacitorTolerance,
        );
        strDesignator += strDesignator.length > 0 ? ',' + refDesignatorCapacitor : refDesignatorCapacitor;
      }
    }
    // get reference designator for current component OpAmp
    let opAmp = opAmpSource.getOpAmp(stageDetails[i].actualStage.opAmp);
    let refDesignatorOpAmp = _referenceDesignatorOpAmp(opAmp, stageDetails[i]);
    strDesignator += strDesignator.length > 0 ? ',' + refDesignatorOpAmp : refDesignatorOpAmp;

    // get the finishing touches for the current component
    let finishingTouchesCurrentComp = _finishingTouches(vsMinus);

    // loop through the byPass capacitors to get the reference designator
    for (let l = 0; l < finishingTouchesCurrentComp.bypassCapacitors.length; l++) {
      let bypassCapacitorDesignator = _referenceDesignatorBypassCapacitor(
        finishingTouchesCurrentComp.bypassCapacitors[l].name,
        stageDetails[i].stageLetter,
      );
      strDesignator += strDesignator.length > 0 ? ',' + bypassCapacitorDesignator : bypassCapacitorDesignator;
    }
    // referencing extraComponents from above (line 765), splitting string for J1A,J1B,J1C etc
    let j1LetterArray = extraComponents.otherAdditions[2].designators.split(',');

    // remove spacing, get stageLetter, add J1x to strDesignator
    for (let m = 0; m < j1LetterArray.length; m++) {
      let subString = j1LetterArray[m].trim();
      let stageLetter = subString.charAt([2]);
      // if stageLetter matches this components stageLetter add to strDesignator
      if (stageLetter === stageDetails[i].stageLetter) {
        strDesignator += strDesignator.length > 0 ? ',' + subString : subString;
      }
    }
    // get the evalboard model number and stage text for current component
    let getAvailableEvalBoard = _availableEvaluationBoard(opAmp, stageDetails[i]);
    orderEvalBoardArray.push({
      stage: stageDetails[i].stageLetter,
      stageType: getAvailableEvalBoard.stageType,
      stageImplementation: getAvailableEvalBoard.stageImplementation,
      stageChannel: getAvailableEvalBoard.stageChannel,
      evalBoardModelNumber: getAvailableEvalBoard.evalBoardModelNumber,
      partsOnEvalBoard: strDesignator,
    });
  }
  return orderEvalBoardArray;
}
export function orderSamples(stageDetails, opAmpSource) {
  let opAmpList = [];
  let opAmpModelsArray = [];
  for (let i = 0; i < stageDetails.length; i++) {
    let opAmpName = stageDetails[i].actualStage.opAmp.toLowerCase();
    if (!opAmpList.includes(opAmpName)) {
      opAmpList.push(opAmpName);
    }
  }
  for (let i = 0; i < opAmpList.length; i++) {
    opAmpModelsArray.push(opAmpSource.getOpAmpModelsArray(opAmpList[i]));
  }
  let opAmpModelsResult = RSVP.Promise.all(opAmpModelsArray);
  return opAmpModelsResult.then((opAmpModels) => {
    console.log(opAmpModels);
    return opAmpModels.filter((a) => a !== null);
  });
}

////////////////////////////////////////////////////////////////////////////////
// Internal Support Functions                                                 //
////////////////////////////////////////////////////////////////////////////////

function _materialAndPackageForResistors(toleranceValue) {
  let pkg = '',
    material = '';
  if (toleranceValue <= FilterConstants.resistorTolerance.fiveTenths) {
    pkg = '0603';
    material = 'Thin Film';
  } else {
    pkg = '0603';
    material = '';
  }
  return { package: pkg, material: material };
}
function _materialAndPackageForCapacitors(value, toleranceValue, boolReferenceBoard) {
  let pkg = '',
    material = '',
    tolerance;

  //check if the tolerance is ideal and get the integer value of the tolerance to compare
  if (toleranceValue !== FilterConstants.capacitorTolerance.ideal) {
    tolerance = parseFloat(toleranceValue);

    if (value <= 10 * 1e-9) {
      material = 'C0G';
      pkg = '0603';
    } else if (value > 10 * 1e-9 && value <= 100 * 1e-9 && tolerance <= 10) {
      material = 'C0G';
      pkg = '1206';
    } else if (value > 10 * 1e-9 && value <= 100 * 1e-9 && tolerance === 20) {
      material = 'X7R';
      pkg = '0603';
    } else if (value > 100 * 1e-9 && value < 10 * 1e-6) {
      material = 'X7R';
      pkg = '1206';
    } else if (value === 0.00001 && boolReferenceBoard === true) {
      material = '{{tantalum}}';
      pkg = '6032';
    }
  }
  return { package: pkg, material: material };
}
function _materialAndPackageForInductors(value, toleranceValue, filterSpecs, filterType) {
  let pkg = '',
    resonanceFrequency,
    material = '';

  if (value >= 330e-9) {
    pkg = '1210';
  } else {
    pkg = '0603';
  }
  switch (filterType) {
    case FilterConstants.filterType.lowPass:
      resonanceFrequency = 10 * Number(filterSpecs.passbandFrequency);
      break;
    case FilterConstants.filterType.highPass:
      resonanceFrequency = 10 * Number(filterSpecs.stopbandFrequency);
      break;
    case FilterConstants.filterType.bandPass:
      resonanceFrequency = 10 * Number(filterSpecs.centerFrequency);
      break;
    case FilterConstants.filterType.notch:
      resonanceFrequency = 10 * Number(filterSpecs.centerFrequency);
      break;
  }
  material =
    'resonance > ' + Format.formatFieldValue(resonanceFrequency, FilterConstants.fieldTypes.Engineering, '3s') + 'Hz';
  return { package: pkg, material: material };
}
function _materialAndPackageForOpAmps(opAmp) {
  var pkg = '',
    material = '';
  if (isSOIC(opAmp.packageCode)) {
    pkg = 'SOIC';
  } else if (isSOICEP(opAmp.packageCode)) {
    pkg = 'SOIC EP';
  } else if (isMSOP(opAmp.packageCode)) {
    pkg = 'MSOP';
  } else if (isMSOPEP(opAmp.packageCode)) {
    pkg = 'MSOP EP';
  } else if (isSOT23(opAmp.packageCode)) {
    pkg = 'SOT-23';
  }
  return { package: pkg, material: material };
}
function _inArray(array, name) {
  for (let a = 0; a < array.length; a++) {
    if (array[a].name === name) {
      return [true, a]; // a returns the index at which the key is found
    }
  }
  return [false, -1];
}
function _getExtraComponentsCount(stageNum) {
  let quantity;

  //check stageNum set quantity
  switch (true) {
    case stageNum <= 4:
      quantity = 4;
      //J1 for each stage
      break;
    case stageNum >= 5 && stageNum <= 8:
      quantity = 8;
      break;
    case stageNum > 8:
      //this shouldn't happen (We will never support  Please comment the code to this effect so future programmers don't attempt.)
      quantity = -1;
      break;
  }
  return quantity;
}
function _billOfMaterialsTable(array, formatValue, unit) {
  //if incoming array is empty, can immediately return empty array back
  if (array.length === 0) return [];

  let billOfMaterialDisplay = new Array();
  let arrayNew = new Array();
  let arrayCount = new Array();
  let dlist = '';
  let boolFound = false;
  let arrayClone = clone(array[0]);

  // clone and push the first element of the array
  arrayNew.push(arrayClone);
  arrayCount.push(1);

  for (let b = 1; b < array.length; b++) {
    dlist = array[b].refDesignator;
    boolFound = false;

    // compare each element of array with the elements of arrayNew created
    for (let i = 0; i < arrayNew.length; i++) {
      if (
        array[b].value === arrayNew[i].value &&
        array[b].tolerance === arrayNew[i].tolerance &&
        array[b].package === arrayNew[i].package &&
        array[b].material === arrayNew[i].material
      ) {
        arrayNew[i].refDesignator = arrayNew[i].refDesignator + ', ' + dlist;

        if (array[b].count > 1) {
          arrayCount[i]++;
        }
        arrayCount[i]++;
        boolFound = true;
        break;
      }
    }

    // if boolFound is true, continue with the loop
    if (boolFound) continue;

    // if any element in from the array doesnt match with elements of arrayNew, clone and push it to arrayNew
    let tempObj = clone(array[b]);
    arrayNew.push(tempObj);
    arrayCount.push(1);
  }

  for (var j = 0; j < arrayNew.length; j++) {
    if (formatValue) {
      arrayNew[j].value = Format.formatFieldValue(arrayNew[j].value, FilterConstants.fieldTypes.Engineering, '5s');
      arrayNew[j].value = arrayNew[j].value + unit;
    }

    // push the elements of arrayNew to billOfMaterialsDisplay
    billOfMaterialDisplay.push({
      count: arrayCount[j],
      designators: arrayNew[j].refDesignator,
      value: arrayNew[j].value,
      prodURL: arrayNew[j].prodURL,
      package: arrayNew[j].package,
      tolerance: arrayNew[j].tolerance,
      material: arrayNew[j].material,
      italicRow: arrayNew[j].italicRow,
    });
  }

  return billOfMaterialDisplay;
}
function _getToleranceComponents(circuitData, supportedComponents) {
  let components = [];
  for (let i = 0; i < supportedComponents.length; i++) {
    let componentName = supportedComponents[i];
    let componentValue = circuitData.get(componentName + '.value');
    let toleranceValue = circuitData.get(componentName + '.finalTolerance');
    if (componentValue !== 0 && !isNearInfinity(componentValue) && toleranceValue !== 'ideal')
      components.push({ name: componentName.toUpperCase(), tolerance: toleranceValue });
  }
  return components;
}
function _getValidCapacitorsAndResistors(stageData, circuitData, includeInductors) {
  let validResistors = [];
  let validCapacitors = [];
  let validInductors = [];
  let stageImplementation = stageData.implementation.replace(/ /g, '');
  let stageType = camelize(stageData.filterName.substring(10).replace(/_/g, '-'));

  // Add the appropriate resistors and capacitors to the temp arrays based on implementation.
  switch (stageImplementation) {
    case FilterConstants.implementationType.gain: {
      // Add resistors.
      validResistors.push({ name: FilterConstants.resistorNames.r3, value: circuitData.r3.value });
      validResistors.push({ name: FilterConstants.resistorNames.r4, value: circuitData.r4.value });
      break;
    }
    case FilterConstants.implementationType.firstOrder: {
      // Add resistors.
      validResistors.push({ name: FilterConstants.resistorNames.r1, value: circuitData.r1.value });
      validResistors.push({ name: FilterConstants.resistorNames.r3, value: circuitData.r3.value });
      validResistors.push({ name: FilterConstants.resistorNames.r4, value: circuitData.r4.value });
      // Add capacitors.
      validCapacitors.push({ name: FilterConstants.capacitorNames.c1, value: circuitData.c1.value });
      break;
    }
    case FilterConstants.implementationType.sallenKey: {
      // Add resistors.
      validResistors.push({ name: FilterConstants.resistorNames.r1, value: circuitData.r1.value });
      validResistors.push({ name: FilterConstants.resistorNames.r2, value: circuitData.r2.value });
      validResistors.push({ name: FilterConstants.resistorNames.r3, value: circuitData.r3.value });
      validResistors.push({ name: FilterConstants.resistorNames.r4, value: circuitData.r4.value });
      // Add capacitors.
      validCapacitors.push({ name: FilterConstants.capacitorNames.c1, value: circuitData.c1.value });
      validCapacitors.push({ name: FilterConstants.capacitorNames.c2, value: circuitData.c2.value });
      break;
    }
    case FilterConstants.implementationType.inductor: {
      // Add resistors.
      validResistors.push({ name: FilterConstants.resistorNames.r1, value: circuitData.r1.value });
      validResistors.push({ name: FilterConstants.resistorNames.r3, value: circuitData.r3.value });
      validResistors.push({ name: FilterConstants.resistorNames.r4, value: circuitData.r4.value });
      // Add capacitor
      validCapacitors.push({ name: FilterConstants.capacitorNames.c1, value: circuitData.c1.value });
      //Add inductor
      validInductors.push({ name: FilterConstants.inductorNames.l1, value: circuitData.l1.value });
      break;
    }
    case FilterConstants.implementationType.multipleFeedback: {
      if (stageType === FilterConstants.filterType.lowPass) {
        // Add resistors.
        validResistors.push({ name: FilterConstants.resistorNames.r1, value: circuitData.r1.value });
        validResistors.push({ name: FilterConstants.resistorNames.r2, value: circuitData.r2.value });
        validResistors.push({ name: FilterConstants.resistorNames.r5, value: circuitData.r5.value });
        // Add capacitors.
        validCapacitors.push({ name: FilterConstants.capacitorNames.c1, value: circuitData.c1.value });
        validCapacitors.push({ name: FilterConstants.capacitorNames.c2, value: circuitData.c2.value });
      } else {
        // Add resistors.
        validResistors.push({ name: FilterConstants.resistorNames.r1, value: circuitData.r1.value });
        validResistors.push({ name: FilterConstants.resistorNames.r2, value: circuitData.r2.value });
        // Add capacitors.
        validCapacitors.push({ name: FilterConstants.capacitorNames.c1, value: circuitData.c1.value });
        validCapacitors.push({ name: FilterConstants.capacitorNames.c2, value: circuitData.c2.value });
        validCapacitors.push({ name: FilterConstants.capacitorNames.c5, value: circuitData.c5.value });
      }
      break;
    }
    case FilterConstants.implementationType.deliyannisFriend: {
      if (stageType === FilterConstants.filterType.bandPass) {
        // Add resistors.
        validResistors.push({ name: FilterConstants.resistorNames.r1, value: circuitData.r1.value });
        validResistors.push({ name: FilterConstants.resistorNames.r2, value: circuitData.r2.value });
        validResistors.push({ name: FilterConstants.resistorNames.r3, value: circuitData.r3.value });
        validResistors.push({ name: FilterConstants.resistorNames.r4, value: circuitData.r4.value });
        validResistors.push({ name: FilterConstants.resistorNames.r5, value: circuitData.r5.value });
        // Add capacitors.
        validCapacitors.push({ name: FilterConstants.capacitorNames.c1, value: circuitData.c1.value });
        validCapacitors.push({ name: FilterConstants.capacitorNames.c2, value: circuitData.c2.value });
      } else if (stageType === FilterConstants.filterType.notch) {
        // Add resistors.
        validResistors.push({ name: FilterConstants.resistorNames.r1, value: circuitData.r1.value });
        validResistors.push({ name: FilterConstants.resistorNames.r2, value: circuitData.r2.value });
        validResistors.push({ name: FilterConstants.resistorNames.r3, value: circuitData.r3.value });
        validResistors.push({ name: FilterConstants.resistorNames.r4, value: circuitData.r4.value });
        validResistors.push({ name: FilterConstants.resistorNames.r5, value: circuitData.r5.value });
        validResistors.push({ name: FilterConstants.resistorNames.r6, value: circuitData.r6.value });
        // Add capacitors.
        validCapacitors.push({ name: FilterConstants.capacitorNames.c1, value: circuitData.c1.value });
        validCapacitors.push({ name: FilterConstants.capacitorNames.c2, value: circuitData.c2.value });
      }
      break;
    }
  }
  if (includeInductors) return [validCapacitors, validResistors, validInductors];
  else return [validCapacitors, validResistors];
}
function _getResistorBOM(stageDetail, validResistors, toleranceComponents, resistorTolerance) {
  let billOfMaterialObj = [];
  for (let j = 0; j < validResistors.length; j++) {
    let boolResistor = _inArray(toleranceComponents, validResistors[j].name);
    let toleranceValue = boolResistor[0] ? toleranceComponents[boolResistor[1]].tolerance : resistorTolerance;
    let refDesignatorResistor = _referenceDesignator(
      stageDetail,
      validResistors[j].name,
      validResistors[j].value,
      toleranceValue,
    );
    let materialAndPackageResistor = _materialAndPackageForResistors(toleranceValue);
    billOfMaterialObj.push({
      refDesignator: refDesignatorResistor,
      value: validResistors[j].value,
      prodURL: null,
      package: materialAndPackageResistor.package,
      material: validResistors[j].value === 0 ? '' : materialAndPackageResistor.material,
      tolerance: validResistors[j].value === 0 ? '' : toleranceValue,
      italicRow: validResistors[j].value === 0,
    });
  }
  return billOfMaterialObj;
}
function _getCapacitorBOM(stageDetail, validCapacitors, toleranceComponents, capacitorTolerance, boolReferenceBoard) {
  let billOfMaterialObj = [];
  for (let j = 0; j < validCapacitors.length; j++) {
    var boolCapacitor = _inArray(toleranceComponents, validCapacitors[j].name);
    let toleranceValue = boolCapacitor[0] ? toleranceComponents[boolCapacitor[1]].tolerance : capacitorTolerance;
    let refDesignatorCapacitor = _referenceDesignator(
      stageDetail,
      validCapacitors[j].name,
      validCapacitors[j].value,
      toleranceValue,
    );
    let materialAndPackageCapacitor = _materialAndPackageForCapacitors(
      validCapacitors[j].value,
      toleranceValue,
      boolReferenceBoard,
    );
    billOfMaterialObj.push({
      refDesignator: refDesignatorCapacitor,
      value: validCapacitors[j].value,
      prodURL: null,
      package: materialAndPackageCapacitor.package,
      material: materialAndPackageCapacitor.material,
      tolerance: toleranceValue,
      italicRow: false,
    });
  }
  return billOfMaterialObj;
}
function _getInductorBOM(
  stageDetail,
  validInductors,
  toleranceComponents,
  inductorTolerance,
  specificationsInput,
  filterType,
) {
  let billOfMaterialObj = [];
  for (let j = 0; j < validInductors.length; j++) {
    let boolInductor = _inArray(toleranceComponents, validInductors[j].name);
    let toleranceValue = boolInductor[0] ? toleranceComponents[boolInductor[1]].tolerance : inductorTolerance;
    let refDesignatorInductor = _referenceDesignator(
      stageDetail,
      validInductors[j].name,
      validInductors[j].value,
      toleranceValue,
    );
    let materialAndPackageInductor = _materialAndPackageForInductors(
      validInductors[j].value,
      toleranceValue,
      specificationsInput,
      filterType,
    );
    billOfMaterialObj.push({
      refDesignator: refDesignatorInductor,
      value: validInductors[j].value,
      prodURL: null,
      package: materialAndPackageInductor.package,
      material: materialAndPackageInductor.material,
      tolerance: toleranceValue,
      italicRow: false,
    });
  }
  return billOfMaterialObj;
}
function _getOpAmpBOM(stageDetail, opAmpSource) {
  let billOfMaterialObj = [];
  let opAmp = opAmpSource.getOpAmp(stageDetail.actualStage.opAmp);
  let refDesignatorOpAmp = _referenceDesignatorOpAmp(opAmp, stageDetail);
  let packageAndMaterialsOpAmp = _materialAndPackageForOpAmps(opAmp);
  let prodURLString = '{{homeURL}}' + '/' + opAmp.generic.toUpperCase() + '.html';
  billOfMaterialObj.push({
    refDesignator: refDesignatorOpAmp,
    value: opAmp.partNumber,
    prodURL: prodURLString,
    package: packageAndMaterialsOpAmp.package,
    material: packageAndMaterialsOpAmp.material,
    tolerance: '',
    italicRow: false,
  });
  return billOfMaterialObj;
}
function _getBypassCapacitorsBOM(validBypassCapacitors, stageLetter, boolReferenceBoard) {
  let billOfMaterialObj = [];
  for (let l = 0; l < validBypassCapacitors.length; l++) {
    let bypassCapacitorDesignator = _referenceDesignatorBypassCapacitor(validBypassCapacitors[l].name, stageLetter);
    let byPassCapMaterialsAndPackage = _materialAndPackageForCapacitors(
      validBypassCapacitors[l].value,
      validBypassCapacitors[l].tolerance,
      boolReferenceBoard,
    );
    billOfMaterialObj.push({
      refDesignator: bypassCapacitorDesignator,
      value: validBypassCapacitors[l].value,
      prodURL: null,
      package: byPassCapMaterialsAndPackage.package,
      material: byPassCapMaterialsAndPackage.material,
      tolerance: validBypassCapacitors[l].tolerance,
      italicRow: false,
    });
  }
  return billOfMaterialObj;
}
function _referenceDesignator(stageDetails, name, value, toleranceValue) {
  let refDesignator = '';
  let stageImplementation = stageDetails.implementation.replace(/ /g, ''),
    stageType = camelize(stageDetails.filterName.substring(10).replace(/_/g, '-')),
    stageLetter = stageDetails.stageLetter,
    firstOrderLowPass =
      stageImplementation === FilterConstants.implementationType.firstOrder &&
      stageType === FilterConstants.filterType.lowPass,
    firstOrderHighPass =
      stageImplementation === FilterConstants.implementationType.firstOrder &&
      stageType === FilterConstants.filterType.highPass;

  switch (name) {
    case FilterConstants.resistorNames.r1: {
      //Major hack: we use R1 internally for first order low pass stage, but display as R2 so it works with eval boards
      refDesignator = firstOrderHighPass
        ? (refDesignator = FilterConstants.resistorNames.r2 + stageLetter)
        : (refDesignator = FilterConstants.resistorNames.r1 + stageLetter);
      break;
    }
    case FilterConstants.resistorNames.r2:
    case FilterConstants.resistorNames.r3:
    case FilterConstants.resistorNames.r4:
    case FilterConstants.resistorNames.r5:
    case FilterConstants.resistorNames.r6:
    case FilterConstants.inductorNames.l1: {
      refDesignator = name + stageLetter;
      break;
    }
    case FilterConstants.capacitorNames.c1: {
      let capacitorPackage = _materialAndPackageForCapacitors(value, toleranceValue);
      //Major hack:  we use C1 internally for first order high pass stage, but display as C2 so it works with eval boards
      if (firstOrderLowPass) {
        if (capacitorPackage.package === '0603') {
          refDesignator = 'C2' + stageLetter;
        } else if (capacitorPackage.package === '1206') {
          refDesignator = 'C6' + stageLetter;
        }
      } else {
        if (capacitorPackage.package === '0603') {
          refDesignator = 'C1' + stageLetter;
        } else if (capacitorPackage.package === '1206') {
          refDesignator = 'C5' + stageLetter;
        }
      }
      break;
    }
    case FilterConstants.capacitorNames.c2: {
      let capacitorPackage = _materialAndPackageForCapacitors(value, toleranceValue);
      if (capacitorPackage.package === '0603') {
        refDesignator = 'C2' + stageLetter;
      } else if (capacitorPackage.package === '1206') {
        refDesignator = 'C6' + stageLetter;
      }
      break;
    }
    case FilterConstants.capacitorNames.c3: {
      let capacitorPackage = _materialAndPackageForCapacitors(value, toleranceValue);
      if (capacitorPackage.package === '0603') {
        refDesignator = 'C3' + stageLetter;
      } else if (capacitorPackage.package === '1206') {
        refDesignator = 'C7' + stageLetter;
      }
      break;
    }
    case FilterConstants.capacitorNames.c5: {
      // for Multiple Feedback only - c5 is used in all calculations, switch to C3/C7 on schematic/BOM
      let capacitorPackage = _materialAndPackageForCapacitors(value, toleranceValue);
      if (capacitorPackage.package === '0603') {
        refDesignator = 'C3' + stageLetter;
      } else if (capacitorPackage.package === '1206') {
        refDesignator = 'C7' + stageLetter;
      }
      break;
    }
  }
  return refDesignator;
}
function _referenceDesignatorOpAmp(opAmp, stageDetails) {
  // Call function to get Op Amp Reference Designator (U1 or U2)
  return getOpAmpReferenceDesignator(opAmp.packageCode, opAmp.numberChannels) + stageDetails.stageLetter;
}
function _referenceDesignatorBypassCapacitor(bypassCapacitorName, stageLetter) {
  let refDesignatorBypassCap;
  if (bypassCapacitorName !== null) {
    // get the reference designator for bypass Capacitor
    if (bypassCapacitorName === 'bypassGroundPlusVS') {
      refDesignatorBypassCap = FilterConstants.bypassCapacitorNames.c9 + stageLetter;
    } else if (bypassCapacitorName === 'bypassGroundMinusVS') {
      refDesignatorBypassCap = FilterConstants.bypassCapacitorNames.c0 + stageLetter;
    }
  }
  return refDesignatorBypassCap;
}
function _finishingTouches(vsMinus) {
  var bypassCapacitors = [],
    opAmpPin = {};
  // add byPass capacitors with tolerance 20% based on dual or single supply
  if (vsMinus !== 0) {
    // its a dual supply, hence add two tantalum, one connected to +vs and ground and other to -vs and ground
    bypassCapacitors.push({
      name: 'bypassGroundPlusVS',
      value: 0.0000001,
      tolerance: FilterConstants.capacitorTolerance.twenty,
      type: 'positive',
    });
    bypassCapacitors.push({
      name: 'bypassGroundMinusVS',
      value: 0.0000001,
      tolerance: FilterConstants.capacitorTolerance.twenty,
      type: 'negative',
    });
  } else {
    // its a single supply hence add just one tantalum capacitor
    bypassCapacitors.push({
      name: 'bypassGroundPlusVS',
      value: 0.0000001,
      tolerance: FilterConstants.capacitorTolerance.twenty,
      type: 'positive',
    });
  }
  return { opAmpPins: opAmpPin, bypassCapacitors: bypassCapacitors };
}
function _getReferenceStage() {
  let referenceResistors = new Array(),
    referenceCapacitors = new Array(),
    referenceObject = new Array();

  // we are setting the boolReferenceBoard to true
  let boolReferenceBoard = true;

  // get the resistor names, values and tolerance
  referenceResistors.push({
    designator: FilterConstants.resistorNames.r1 + 'M',
    value: 10000,
    tolerance: FilterConstants.resistorTolerance.one,
  });
  referenceResistors.push({
    designator: FilterConstants.resistorNames.r2 + 'M',
    value: 10000,
    tolerance: FilterConstants.resistorTolerance.one,
  });
  referenceResistors.push({
    designator: FilterConstants.resistorNames.r3 + 'M',
    value: 4990,
    tolerance: FilterConstants.resistorTolerance.one,
  });

  //get the capacitor names, values and tolerance
  referenceCapacitors.push({
    designator: FilterConstants.capacitorNames.c1 + 'M',
    value: 0.00001,
    tolerance: FilterConstants.capacitorTolerance.twenty,
  });
  referenceCapacitors.push({
    designator: FilterConstants.capacitorNames.c2 + 'M',
    value: 0.00001,
    tolerance: FilterConstants.capacitorTolerance.twenty,
  });
  referenceCapacitors.push({
    designator: FilterConstants.capacitorNames.c3 + 'M',
    value: 0.0000001,
    tolerance: FilterConstants.capacitorTolerance.twenty,
  });
  referenceCapacitors.push({
    designator: FilterConstants.capacitorNames.c4 + 'M',
    value: 0.0000001,
    tolerance: FilterConstants.capacitorTolerance.twenty,
  });

  // get the reference capacitor for the motherboard
  referenceCapacitors.push({
    designator: FilterConstants.bypassCapacitorNames.c9 + 'M',
    value: 0.0000001,
    tolerance: FilterConstants.capacitorTolerance.twenty,
  });

  // loop through the reference resistors and get the reference designator, value, package , material and tolerance
  for (let k = 0; k < referenceResistors.length; k++) {
    let materialAndPackageResistor = _materialAndPackageForResistors(referenceResistors[k].tolerance);
    referenceObject.push({
      refDesignator: referenceResistors[k].designator,
      value: referenceResistors[k].value,
      package: materialAndPackageResistor.package,
      material: materialAndPackageResistor.material,
      tolerance: referenceResistors[k].tolerance,
    });
  }
  // loop through the reference capacitors and get thereference designator, value, package , material and tolerance
  for (let m = 0; m < referenceCapacitors.length; m++) {
    let materialAndPackageCapacitors = _materialAndPackageForCapacitors(
      referenceCapacitors[m].value,
      referenceCapacitors[m].tolerance,
      boolReferenceBoard,
    );
    referenceObject.push({
      refDesignator: referenceCapacitors[m].designator,
      value: referenceCapacitors[m].value,
      package: materialAndPackageCapacitors.package,
      material: materialAndPackageCapacitors.material,
      tolerance: referenceCapacitors[m].tolerance,
    });
  }
  //reference designator, value, package , material and tolerance for the reference Circuit opAmp
  referenceObject.push({ refDesignator: 'U1M', value: 'AD8031', package: 'SOIC', material: '', tolerance: '' });

  return referenceObject;
}
function _getTantalumCapacitors(vsMinus) {
  var tantalumCapacitors = new Array();
  // add tantalum capacitors with tolerance 20% based on dual or single supply
  if (vsMinus !== 0) {
    // its a dual supply, hence add two tantalum, one connected to +vs and ground and other to -vs and ground
    tantalumCapacitors.push({
      designator: FilterConstants.tantalumCapacitorNames.c101m,
      value: 0.00001,
      tolerance: FilterConstants.capacitorTolerance.twenty,
      type: 'positive',
    });
    tantalumCapacitors.push({
      designator: FilterConstants.tantalumCapacitorNames.c100m,
      value: 0.00001,
      tolerance: FilterConstants.capacitorTolerance.twenty,
      type: 'negative',
    });
  } else {
    // its a single supply hence add just one tantalum capacitor
    tantalumCapacitors.push({
      designator: FilterConstants.tantalumCapacitorNames.c101m,
      value: 0.00001,
      tolerance: FilterConstants.capacitorTolerance.twenty,
      type: 'positive',
    });
  }
  return tantalumCapacitors;
}
function _getExtraComponentsBOM(stageDetails, quantity, referenceStageUsed) {
  let stageNum = stageDetails.length,
    j1String = '',
    jMString = '',
    stageCounter = stageNum,
    originalQuantity = quantity,
    adjustedQuantity = quantity;
  let resistorAdditions = [],
    otherAdditions = [];

  if (quantity > 4 && quantity <= 8) {
    stageCounter = stageNum - 4;
    adjustedQuantity = 4;
  }

  for (let i = 0; i < stageNum; i++) {
    j1String += ' J1' + stageDetails[i].stageLetter + ',';
  }

  // remove trailing commas
  if (j1String.charAt(j1String.length - 1) === ',') {
    j1String = j1String.slice(0, -1);
  }

  if (originalQuantity <= 4) {
    otherAdditions.push({
      designators: 'J1M, J2M, J3M, J4M',
      value: '67996-206HLF',
      package: '2x3 0.1" ' + '{{header}}',
      material: '',
      tolerance: '',
      count: 4,
      italicRow: true,
      prodURL: null,
    });
  } else {
    otherAdditions.push({
      designators: '2 x J1M, 2 x J2M, 2 x J3M, 2 x J4M',
      value: '67996-206HLF',
      package: '2x3 0.1" ' + '{{header}}',
      material: '',
      tolerance: '',
      count: 8,
      italicRow: true,
      prodURL: null,
    });
  }

  // 4 or 8 - number of stages if this is 0 we don't push any JxM strings
  if (stageNum !== originalQuantity) {
    while (stageCounter < adjustedQuantity) {
      jMString += ' J' + (stageCounter + 1) + 'M,';
      stageCounter++;
    }
    if (jMString.charAt(jMString.length - 1) === ',') {
      jMString = jMString.slice(0, -1);
    }
    otherAdditions.push({
      designators: jMString.trim(),
      value: '65474-010LF',
      package: '0.1" ' + '{{jumper}}',
      material: '',
      tolerance: '',
      count: originalQuantity - stageNum,
      italicRow: true,
      prodURL: null,
    });
  }
  otherAdditions.push({
    designators: j1String.trim(),
    value: 'BCS-103-L-D-TE',
    package: '2x3 0.1" ' + '{{socket}}',
    material: '',
    tolerance: '',
    count: stageNum,
    italicRow: true,
    prodURL: null,
  }); //check

  // R5M, J5/J6, +VS,-VS,GND
  if (stageNum <= 4) {
    resistorAdditions.push({
      refDesignator: 'R5M',
      value: 0,
      package: '0603',
      material: '',
      tolerance: '',
      count: 1,
      italicRow: true,
      prodURL: null,
    });
    otherAdditions.push({
      designators: 'J5M, J6M',
      value: '142-0701-851',
      package: '{{sma-jack}}',
      material: '',
      tolerance: '',
      count: 2,
      italicRow: true,
      prodURL: null,
    });
    otherAdditions.push({
      designators: '+VS, -VS, GND',
      value: '68000-101HLF',
      package: '{{test-pin}}',
      material: '',
      tolerance: '',
      count: 3,
      italicRow: true,
      prodURL: null,
    });
  }
  // R5M, J5/J6, +VS,-VS,GND, 2 x C3M, IN to Out, REF to REF
  else if (stageNum > 4 && stageNum <= 8) {
    resistorAdditions.push({
      refDesignator: '2 x R5M',
      value: 0,
      package: '0603',
      material: '',
      tolerance: '',
      count: 2,
      prodURL: null,
    });
    otherAdditions.push({
      designators: '2 x J5M, 2 x J6M',
      value: '142-0701-851',
      package: '{{sma-jack}}',
      material: '',
      tolerance: '',
      count: 4,
      italicRow: true,
      prodURL: null,
    });
    otherAdditions.push({
      designators: '2 x +VS, 2 x -VS, 2 x GND',
      value: '68000-101HLF',
      package: '{{test-pin}}',
      material: '',
      tolerance: '',
      count: 6,
      italicRow: true,
      prodURL: null,
    });
    otherAdditions.push({
      designators: '2 x C3M',
      value: '100nF',
      package: '0603',
      material: 'X7R',
      tolerance: '20%',
      count: 2,
      italicRow: true,
      prodURL: null,
    });
    otherAdditions.push({
      designators: 'IN to OUT',
      value: '501-1253-ND',
      package: '{{sma-male}}',
      material: '',
      tolerance: '',
      count: 1,
      italicRow: true,
      prodURL: null,
    });
    otherAdditions.push({
      designators: 'REF to REF',
      value: 'wire',
      package: '',
      material: '',
      tolerance: '',
      count: 1,
      italicRow: true,
      prodURL: null,
    });
  }

  // JP1/JP2 (adjustedQuantity 1)
  if (referenceStageUsed) {
    resistorAdditions.push({
      refDesignator: 'JP1',
      value: 0,
      package: '0603',
      material: '',
      tolerance: '',
      count: 1,
      italicRow: true,
      prodURL: null,
    });
  } else {
    resistorAdditions.push({
      refDesignator: 'JP2',
      value: 0,
      package: '0603',
      material: '',
      tolerance: '',
      count: 1,
      italicRow: true,
      prodURL: null,
    });
  }

  for (let i = 0; i < stageNum; i++) {
    let stageImplementation = stageDetails[i].implementation.replace(/ /g, '');
    let stageType = camelize(stageDetails[i].filterName.substring(10).replace(/_/g, '-'));
    let stageLetter = stageDetails[i].stageLetter;
    if (stageImplementation === FilterConstants.implementationType.firstOrder) {
      if (stageType === FilterConstants.filterType.lowPass) {
        resistorAdditions.push({
          refDesignator: 'R2' + stageLetter,
          value: 0,
          package: '0603',
          material: '',
          tolerance: '',
          count: 1,
          italicRow: true,
          prodURL: null,
        });
      }
      if (stageType === FilterConstants.filterType.highPass) {
        resistorAdditions.push({
          refDesignator: 'C2' + stageLetter,
          value: 0,
          package: '0603',
          material: '',
          tolerance: '',
          count: 1,
          italicRow: true,
          prodURL: null,
        });
      }
    }
  }
  return { resistorAdditions: resistorAdditions, otherAdditions: otherAdditions };
}
function _motherBoardDesignators(vsMinus, needReferenceStage) {
  var motherBoardDesignatorArray = new Array(),
    refCircuitArray;

  // get the designators for the reference Circuit if any
  if (needReferenceStage) {
    refCircuitArray = _getReferenceStage();
    //loop through the reference circuit Array and push the designators, values, materials, packages, and tolerances to the billOfMaterials
    for (let s = 0; s < refCircuitArray.length; s++) {
      motherBoardDesignatorArray.push(refCircuitArray[s].refDesignator);
    }
  }
  // get the designators for tantalum capacitor
  let motherBoardTantalum = _getTantalumCapacitors(vsMinus);
  //loop through the motherboard tantalum capacitors to get the designators
  for (var q = 0; q < motherBoardTantalum.length; q++) {
    motherBoardDesignatorArray.push(motherBoardTantalum[q].designator);
  }
  return motherBoardDesignatorArray;
}
function _availableEvaluationBoard(opAmp, stageDetail) {
  let stageImplementation = stageDetail.implementation.replace(/ /g, '');
  let stageType = camelize(stageDetail.filterName.substring(10).replace(/_/g, '-'));
  let evalBoardModelNumber = null;
  let ebsType = '';
  let stageTypeText = '';
  switch (stageType) {
    case FilterConstants.filterType.lowPass:
      ebsType = FilterConstants.evalBoard.type.lowPass;
      stageTypeText = dasherize(FilterConstants.filterType.lowPass);
      break;
    case FilterConstants.filterType.highPass:
      ebsType = FilterConstants.evalBoard.type.highPass;
      stageTypeText = dasherize(FilterConstants.filterType.highPass);
      break;
    case FilterConstants.filterType.bandPass:
      ebsType = FilterConstants.evalBoard.type.bandPass;
      stageTypeText = dasherize(FilterConstants.filterType.bandPass);
      break;
    case FilterConstants.filterType.bandStop:
      ebsType = FilterConstants.evalBoard.type.bandStop;
      stageTypeText = dasherize(FilterConstants.filterType.bandStop);
      break;
    case FilterConstants.filterType.notch:
      ebsType = FilterConstants.evalBoard.type.notch;
      stageTypeText = dasherize(FilterConstants.filterType.notch);
      break;
    case FilterConstants.filterType.gain:
      ebsType = FilterConstants.evalBoard.type.gain;
      stageTypeText = dasherize(FilterConstants.filterType.gain);
      break;
    default:
      ebsType = '';
      stageImplementationText = 'none';
      break;
  }
  let ebsImplementation = '';
  let stageImplementationText = '';
  switch (stageImplementation) {
    case FilterConstants.implementationType.firstOrder:
      ebsImplementation = FilterConstants.evalBoard.implementation.firstOrder;
      // First Order will always be Buffered RC when displayed
      stageImplementationText = 'buffered-rc';
      break;
    case FilterConstants.implementationType.sallenKey:
      ebsImplementation = FilterConstants.evalBoard.implementation.sallenKey;
      stageImplementationText = dasherize(FilterConstants.implementationType.sallenKey);
      break;
    case FilterConstants.implementationType.inductor:
      ebsImplementation = FilterConstants.evalBoard.implementation.inductor;
      stageImplementationText = dasherize(FilterConstants.implementationType.inductor);
      break;
    case FilterConstants.implementationType.multipleFeedback:
      ebsImplementation = FilterConstants.evalBoard.implementation.multipleFeedback;
      stageImplementationText = dasherize(FilterConstants.implementationType.multipleFeedback);
      break;
    case FilterConstants.implementationType.deliyannisFriend:
      ebsImplementation = FilterConstants.evalBoard.implementation.deliyannisFriend;
      // Note the text conversion here to "Multiple Feedback" to display to customer,
      // even though internally we denote this stage type as Deliyannis Friend
      stageImplementationText = dasherize(FilterConstants.implementationType.multipleFeedback);
      break;
    case FilterConstants.implementationType.gain:
      ebsImplementation = FilterConstants.evalBoard.implementation.gain;
      // If the stage type is already gain, the stageImplementation will be blank to
      // avoid redundancy as the stage text is type + implementation like Low Pass Sallen Key
      // as to avoid something like 'Gain Gain'
      stageImplementationText =
        stageTypeText !== dasherize(FilterConstants.filterType.gain)
          ? dasherize(FilterConstants.implementationType.gain)
          : 'none';
      break;
    default:
      ebsImplementation = '';
      stageImplementationText = 'none';
      break;
  }
  let ebsOpAmpChannel = '';
  let stageChannel = '';
  switch (opAmp.numberChannels.toString()) {
    case '1':
      if (isSOIC(opAmp.packageCode) || isSOICEP(opAmp.packageCode) || isSOT23(opAmp.packageCode)) {
        ebsOpAmpChannel = FilterConstants.evalBoard.channel.one;
        stageChannel = 'single';
      } else {
        ebsOpAmpChannel = FilterConstants.evalBoard.channel.other;
        stageChannel = 'none';
      }
      break;
    case '2':
      if (
        isSOIC(opAmp.packageCode) ||
        isSOICEP(opAmp.packageCode) ||
        isMSOP(opAmp.packageCode) ||
        isMSOPEP(opAmp.packageCode)
      ) {
        ebsOpAmpChannel = FilterConstants.evalBoard.channel.two;
        stageChannel = 'dual';
      } else {
        ebsOpAmpChannel = FilterConstants.evalBoard.channel.other;
        stageChannel = 'none';
      }
      break;
    default:
      ebsOpAmpChannel = FilterConstants.evalBoard.channel.other;
      stageChannel = 'none';
      break;
  }

  // Build Evaluation Board Model
  if (ebsType !== '' && ebsImplementation !== '' && ebsOpAmpChannel !== '') {
    evalBoardModelNumber = FilterConstants.evalBoard.fileBase
      .replace('{{type}}', ebsType)
      .replace('{{implementation}}', ebsImplementation)
      .replace('{{channel}}', ebsOpAmpChannel);
  }

  return {
    evalBoardModelNumber: evalBoardModelNumber,
    stageType: stageTypeText,
    stageImplementation: stageImplementationText,
    stageChannel: stageChannel,
  };
}
